import { render, staticRenderFns } from "./AppAflossenHypotheekdeelEdit.vue?vue&type=template&id=36ae5705&scoped=true&"
import script from "./AppAflossenHypotheekdeelEdit.ts?vue&type=script&lang=ts&"
export * from "./AppAflossenHypotheekdeelEdit.ts?vue&type=script&lang=ts&"
import style0 from "./AppAflossenHypotheekdeelEdit.scss?vue&type=style&index=0&id=36ae5705&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae5705",
  null
  
)

export default component.exports